const initialState = {
	versesIsLoading: false,
	maxPages: 1,
	verses: {
		all: {}
	},
	scheduledVersesData: {},
	scheduledVersesDataIsLoading: false
}

export default function reducer( state = initialState, action ) {
	const { payload } = action

	switch ( action.type ) {
		case 'REQUEST_VERSES_DATA':
			return {
				...state,
				versesIsLoading: true
			}

		case 'RECEIVE_VERSES_DATA':
			return {
				...state,
				versesIsLoading: false,
				verses: {
					...state.verses,
					[ payload.date ]: payload.verses,
					all: {
						...state.verses.all,
						...payload.verses
					}
				}
			}

		case 'RECEIVE_VERSES_DATA_SINGLE':
			return {
				...state,
				versesIsLoading: false,
				verses: {
					...state.verses,
					all: {
						...state.verses.all,
						...payload.verses
					}
				}
			}

		case 'REQUEST_SCHEDULED_VERSES_DATA':
			return {
				...state,
				scheduledVersesDataIsLoading: true
			}

		case 'RECEIVE_SCHEDULED_VERSES_DATA':
			return {
				...state,
				scheduledVersesDataIsLoading: false,
				scheduledVersesData: {
					...state.scheduledVersesData,
					[ payload.date ]: payload.data
				}
			}
	}

	return state
}
